module.exports = __webpack_public_path__ + "media/site_templates/www.localhandyman.net.au/images/feature_2-93ab01f093b55d9277ff11c3d284dbb9.jpeg";